<template>
  <div id="page-consultant-edit">
    <vs-alert
      color="danger"
      title="Bewerber nicht gefunden"
      :active.sync="fetchFailed"
    >
      <span>Berater mit ID: {{ $route.params.id }} nicht gefunden.</span>
      <span>
        <span> Gehe zu </span
        ><router-link
          :to="{ name: 'consultant.overview' }"
          class="text-inherit underline"
          >Alle Berater</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="consultant">
      <div slot="no-body" class="px-6 pt-6">
        <ConsultantGeneral
          :own="consultant.user && me.id === consultant.user.id"
          :value="consultant"
          :user-value="consultant.user"
          @input="updateValue"
          @userInput="updateUserValue"
        />
      </div>
      <div v-if="lastSave" class="text-right last-saved pr-5 pl-5">
        <vs-icon class="text-success" icon="fa-check-circle" icon-pack="far" />
        Zuletzt gespeichert: {{ $d(lastSave, "long-secounds") }}
      </div>
    </vx-card>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ConsultantGeneral from "../form/ConsultantGeneral";

export default {
  components: {
    ConsultantGeneral
  },
  data() {
    return {
      lastSave: new Date(),
      fetchFailed: false,
      saveInterval: null,
      saveUserInterval: null
    };
  },
  apollo: {
    me: {
      query: gql`
        query Me {
          me {
            id
          }
        }
      `
    },
    consultant: {
      query: gql`
        query Consultant($id: ID!) {
          consultant(id: $id) {
            id
            salutation
            title
            firstName
            lastName
            shorthandSymbol
            telephone
            telephoneMobile
            fax
            company
            position
            imageID
            zip
            city
            street
            telephoneOffice
            l1OperatorShorthand
            department {
              id
              name
              branchOffice
            }
            website
            user {
              id
              username
              email
              active
              roles {
                id
                name
              }
              group {
                id
                name
              }
              groupAccess {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      error(error) {
        if (error.gqlError.message === "record not found") {
          this.fetchFailed = true;
        } else {
          this.fetchFailed = true;
          // TODO: Display different error message
        }
      }
    }
  },
  methods: {
    updateValue(v) {
      this.consultant = v;
      clearTimeout(this.saveInterval);
      this.saveInterval = setTimeout(async () => {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($id: ID!, $input: ConsultantInput!) {
              updateConsultant(id: $id, input: $input) {
                id
              }
            }
          `,
          variables: {
            id: this.consultant.id,
            input: Object.prepareGqlInput(v, ["department"], ["user"])
          }
        });
        this.lastSave = new Date();
        this.$vs.notify({
          title: "Gespeichert",
          text: "Eingabe wurde erfolgreich gespeichert",
          color: "success",
          icon: "query_builder",
          position: "bottom-center"
        });
      }, 500);
    },
    updateUserValue(v) {
      this.consultant.user = v;
      clearTimeout(this.saveUserInterval);
      this.saveUserInterval = setTimeout(async () => {
        if (this.me.id === this.consultant.user.id) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation($input: UserUpdateInput!) {
                ownUserUpdate(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: Object.prepareGqlInput(
                v,
                [],
                ["roles", "group", "groupAccess"]
              )
            }
          });
        } else {
          await this.$apollo.mutate({
            mutation: gql`
              mutation($id: ID!, $input: UserInput!) {
                userUpdate(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id: this.consultant.user.id,
              input: Object.prepareGqlInput(
                v,
                ["group", "roles"],
                ["oldPassword", "password", "groupAccess"]
              )
            }
          });
        }
        this.lastSave = new Date();
        this.$vs.notify({
          title: "Gespeichert",
          text: "Eingabe wurde erfolgreich gespeichert",
          color: "success",
          icon: "query_builder",
          position: "bottom-center"
        });
      }, 500);
    }
  }
};
</script>
